import React, {FC} from "react";
import {useAxios} from "../../utils/hooks";
import useSafeState from "../../utils/safe-state";
import {Trans} from "@lingui/macro";
import {Breadcrumb, Button, Divider, message, Popconfirm, Tooltip} from "antd";
import {
    DeleteTwoTone,
    PlusOutlined,
    UploadOutlined
} from "@ant-design/icons/lib";
import DtoTable from "../../components/dto-table/dto-table";
import ButtonWithIcon from "../../components/buttons/button-with-icon";
import OrderReceivingModel from "../../models/orderreceivings/order-receiving-model";

const OrderReceivingsScreen: FC = () => {

    const [trigger, setTrigger] = useSafeState(false);

    const handleDelete = (record: any) => {
    };

    const action = (record: any) => {

        return (
            <>
                <Tooltip title={<Trans>Edit</Trans>}>
                </Tooltip>
                <Tooltip title={<Trans>Remove</Trans>}>
                    <Popconfirm
                        title={<Trans>Are you sure want to delete record?</Trans>}
                        onConfirm={() => handleDelete(record)}
                        okText={<Trans>Yes</Trans>}
                        cancelText={<Trans>No</Trans>}>
                        <DeleteTwoTone className={"ActionButtons"} twoToneColor={"red"}/>
                    </Popconfirm>

                </Tooltip>

            </>
        )
    };

    const actions = {
        width: 200,
        render: (text: string, record: any) => action(record),
        title: '',
        fixed: 'right',
        align: 'center'
    };

    const header = (
        <>
            <Button type={'primary'} onClick={() => alert('Add new')} style={{ float: 'left' }}>
                <ButtonWithIcon icon={<PlusOutlined />} text={<Trans>Add new</Trans>} />
            </Button>
            <Divider type="vertical" style={{ float: 'left', fontSize: 'xxx-large' }} />
            <Button onClick={() => alert('Upload File')} style={{ float: 'left' }}>
                <ButtonWithIcon
                    icon={<UploadOutlined />}
                    text={<Trans>.csv upload</Trans>}
                />
            </Button>
            <Divider type="vertical" style={{ float: 'left', fontSize: 'xxx-large' }} />
        </>
    );


    return (<>

            <>

                <Breadcrumb style={{marginBottom: 10}}>
                    <Breadcrumb.Item><Trans id={'Home'}/></Breadcrumb.Item>
                    <Breadcrumb.Item><Trans id={'Order Receivings'}></Trans></Breadcrumb.Item>
                </Breadcrumb>
                <DtoTable
                    model={OrderReceivingModel}
                    trigger={trigger}
                    allowRefreshButton={true}
                    pageSize={100}
                    scroll={{x: 1300, y: "65vh"}}/>
            </>
        </>
    )
}
export default OrderReceivingsScreen;
